// extracted by mini-css-extract-plugin
export default {"recruitment-needs__container":"RecruitmentNeeds_recruitment-needs__container__c6OuQ"};